export const VISIT_CARD_EDITOR_USERNAMES = new Set(["miguel", "migue"]);

export function canManageVisitCardsFromToken(decoded = {}) {
  return VISIT_CARD_EDITOR_USERNAMES.has(
    String(decoded.username || "").trim().toLowerCase(),
  );
}

export function peopleForVisitCards(users = []) {
  const byEmail = new Map();
  for (const user of users) {
    const email = String(user.email || user.EMAIL || "").trim().toLowerCase();
    const key = email || `id:${user.id}`;
    const prev = byEmail.get(key);
    if (!prev) {
      byEmail.set(key, user);
      continue;
    }
    const prevAdmin = slugifyVisitCard(prev.username) === "admin";
    const nextAdmin = slugifyVisitCard(user.username) === "admin";
    if (prevAdmin && !nextAdmin) byEmail.set(key, user);
  }
  return [...byEmail.values()].sort((a, b) =>
    String(a.username || "").localeCompare(String(b.username || "")),
  );
}

export function slugifyVisitCard(value) {
  return String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 80);
}

export function groupVisitCardAddressesByCity(addrs = []) {
  const groups = [];
  const indexByCity = new Map();
  for (const addr of addrs) {
    const city = String(addr?.city || "").trim();
    if (!city) {
      groups.push({
        city: String(addr?.label || "Dirección").trim() || "Dirección",
        items: [addr],
      });
      continue;
    }
    const key = city.toLowerCase();
    if (!indexByCity.has(key)) {
      indexByCity.set(key, groups.length);
      groups.push({ city, items: [] });
    }
    groups[indexByCity.get(key)].items.push(addr);
  }
  return groups;
}
